import { has, pickBy } from 'ramda';
import { stringify } from 'query-string';

const DATA_NOVA_API_END_POINT = process.env.RAZZLE_DATA_NOVA_API_END_POINT;
const DATA_NOVA_API_TOKEN = process.env.RAZZLE_DATA_NOVA_API_TOKEN;

const isValidResult = has('records');

/**
 * Query DataNova
 * @param type:string
 * @param params:Object
 * @returns Promise
 */
const requestDataNova = (type, params) =>
  fetch(
    `${DATA_NOVA_API_END_POINT}/${type}?${stringify({
      apikey: DATA_NOVA_API_TOKEN,
      ...params,
    })}`
  );

/**
 * Search in contact point set
 * @param q:string
 * @param page:Number
 * @returns Promise
 */
export const searchInContactPoint = async (query, page = 0) => {
  const response = await requestDataNova('search', {
    dataset: 'laposte_poincont2',
    q: query,
    facet: ['caracteristique_du_site', 'code_postal', 'localite'],
    rows: 10,
    start: page * 10,
  });
  const data = await response.json();

  if (!isValidResult(data)) {
    throw data;
  }

  const { nhits, records } = data;

  return pickBy((a) => a !== undefined, {
    total: +nhits,
    totalPage: Math.ceil(nhits / 10),
    next: (page + 1) * 10 < +nhits ? page + 1 : undefined,
    prev: page > 0 ? page - 1 : undefined,
    page,
    results: records.map((record) => record.fields),
  });
};
